module.exports = __webpack_public_path__ + "static/img/静止.d1d170a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/车辆/随车吊/静止.png
// module id = 3gbZ
// module chunks = 76